var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.invite)?_c('div',{staticClass:"invite-title is-right"},[_c('p',[_vm._v("\n        Sent from "),_c('strong',[_vm._v(_vm._s(_vm.invite.invited_by.name))]),_vm._v(" at\n        "),_c('strong',[_vm._v(_vm._s(_vm.invite.invited_by.company))]),_vm._v(" on\n        "+_vm._s(_vm.invite.date)+"\n    ")])]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24acac1d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Page/InvitedTitle.vue
// module id = null
// module chunks = 